export const CloseIcon = () => (
  <svg
    width="12"
    height="12"
    viewBox="0 0 14 14"
    fill="none"
    aria-hidden="true"
  >
    <path
      d="M13 1L1 13M1 1L13 13"
      stroke="currentColor"
      strokeWidth="2"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </svg>
);

// export const LinkedinIcon = () => (
//   <svg
//     width="24"
//     height="24"
//     viewBox="0 0 24 24"
//     fill="none"
//     xmlns="http://www.w3.org/2000/svg"
//   >
//     <g transform="translate(0, 1)">
//       {" "}
//       <path
//         d="M5.5 20H9.5V8H5.5V20ZM7.5 6.5C8.8 6.5 9.8 5.5 9.8 4.2C9.8 2.9 8.8 1.9 7.5 1.9C6.2 1.9 5.2 2.9 5.2 4.2C5.2 5.5 6.2 6.5 7.5 6.5ZM11.5 20H15.5V13.5C15.5 12.5 16.3 11.7 17.3 11.7C18.3 11.7 19.1 12.5 19.1 13.5V20H23.1V12.8C23.1 10.2 21.6 8 18.3 8C16.8 8 15.6 8.8 14.9 9.9V8H11.5V20Z"
//         stroke="currentColor"
//         strokeWidth="1.6"
//         strokeLinecap="round"
//         strokeLinejoin="round"
//       />
//     </g>
//   </svg>
// );

export const XIcon = () => (
  <svg
    width="20"
    height="20"
    viewBox="0 0 24 24"
    fill="currentColor"
    stroke="rgba(0, 0, 0, 0.1)"
    strokeWidth="0.1"
    aria-hidden="true"
    style={{ overflow: "visible" }}
  >
    <path d="M18.244 2.25h3.308l-7.227 8.26 8.502 11.24H16.17l-5.214-6.817L4.99 21.75H1.68l7.73-8.835L1.254 2.25H8.08l4.713 6.231zm-1.161 17.52h1.833L7.084 4.126H5.117z" />
  </svg>
);
